import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import UserInfoPage from "../components/UserInfoPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
		rank: state.data.userInfo.rank,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const UserInfoPageContainer = connect(mapStateToProps, mapDispatchToProps)(UserInfoPage);

export default UserInfoPageContainer;


// WEBPACK FOOTER //
// ./src/containers/UserInfoPageContainer.js